module.exports = __webpack_public_path__ + "img/host-white.d482f497.svg";